import { Options } from "@contentful/rich-text-react-renderer";
import { BLOCKS, MARKS } from "@contentful/rich-text-types";

const richTextRendererUtils: Options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <strong>{text}</strong>
  },
  renderText: (text) => text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const isBlankLine = /^\s*$/.test((children as string[])?.join(""));

      if (isBlankLine) {
        return <br />;
      }

      return (
        <>
          {children}
          <br />
        </>
      );
    },
    [BLOCKS.HEADING_1]: (node, children) => <h1 style={{ fontSize: "32px", fontWeight: "600" }}>{children}</h1>,
    [BLOCKS.HEADING_2]: (node, children) => <h2 style={{ fontSize: "28px", fontWeight: "600" }}>{children}</h2>
  }
};

export default richTextRendererUtils;
